module.exports = __webpack_public_path__ + "img/footer.f87c6d86.png";